import React, { useState } from "react";
import { Col, Row, Form, message } from "antd";
import { CustomButton, CustomInput } from "../../components";
import { useNavigate } from "react-router-dom";
import { authenticatePassword } from "../../api's/shipment";
import { useSpin } from "../../components/SpinContext";
import LoginLogo from "../../assets/images/b-logo.svg";
import CustomParagraph from "../../components/CustomParagraph";

const AuthenticateShareShipment = ({
  uuid,
  setPasswordRequired,
  setProductDetails,
  setShowAlerts,
}) => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();

  const onFinish = async (values) => {
    if (values.password.length >= 6) {
      setIsFormValid(true);
      const payload = {
        password: values.password,
        token: uuid,
      };
      authenticatePassword(payload)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data?.data?.is_success) {
              setProductDetails(data?.data?.data?.show_product_details);
              setShowAlerts(data?.data?.data?.show_alerts);
              setPasswordRequired(false);
              form.resetFields();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch(() => {
          message.error("Error while generating the shareable link.");
        })
        .finally(() => {
          hideSpin();
          setIsFormValid(false); 
        });
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <img
        src={LoginLogo}
        alt="Login Logo"
        style={{ width: "150px", marginBottom: "20px" }}
      />
      <CustomParagraph
        text="ZoomLogi"
        fontSize={"27px"}
        fontWeight={"600"}
        lineHeight={"49px"}
        marginBottom={0}
      />
      <Form
        layout="vertical"
        form={form}
        name="validateOnly"
        onFinish={onFinish}
        style={{ maxWidth: "300px", margin: "0 auto", textAlign: "center" }}
      >
        <Row gutter={[16, 24]}>
          <Col span={24}>
            <Form.Item
              className="custom-input"
              label="Password"
              name="password"
              style={{textAlign:"left"}}
              rules={[
                { required: true, message: "Please enter your password" },
                {
                  type: "string",
                  min: 6,
                  message: "Password must be at least 6 characters long.",
                },
              ]}
            >
              <CustomInput
                placeholder="Enter password"
                height="36px"
                border="0px"
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                placeholderColor="#5E5E5E"
                lineHeight="38px"
                type="password"
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <CustomButton
              text="Authenticate"
              block="block"
              height="36px"
              bgColor="#000"
              color="#fff"
              borderRadius="8px"
              fontSize={14}
              fontWeight={500}
              isFormValid={isFormValid}
              htmlType="submit"
            />
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AuthenticateShareShipment;
